import React, { useState } from "react"
import { Container, ThemeProvider, StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline"
import Header, { headerHeight } from "containers/Layout/components/Header"
import Footer from "containers/Layout/components/Footer"
import StylesProvider from '@mui/styles/StylesProvider';

import { getMediaFor, MEDIA_BREAKPOINT_KEYS } from "style/style_snippets"
import { Helmet } from "react-helmet"
import customMUITheme from "style/customMaterialUiTheme"
import Disclaimer from "components/Disclaimer/Disclaimer"

const Layout = ({ children }) => {
  const [disclaimerOpenTab, setDisclaimerOpenTab] = useState(null)

  const mainStyle = {
    backgroundColor: "white",
    ...getMediaFor("marginTop", headerHeight.base, {
      [MEDIA_BREAKPOINT_KEYS.xs]: "70px",
      [MEDIA_BREAKPOINT_KEYS.sm]: "90px",
      [MEDIA_BREAKPOINT_KEYS.md]: "90px",
      [MEDIA_BREAKPOINT_KEYS.lg]: "110px",
    }),
  }

  return (
    <StylesProvider injectFirst>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={customMUITheme}>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Mercedes-Benz FOSS</title>
            <link rel="canonical" href="https://www.mercedes-benz.com/" />
          </Helmet>

          <CssBaseline>
            <Header {...{ disclaimerOpenTab, setDisclaimerOpenTab }} />

            <Container disableGutters={true} maxWidth={"xl"}>
              <main css={mainStyle}>{children}</main>
            </Container>
            <Disclaimer {...{ disclaimerOpenTab, setDisclaimerOpenTab }} />
            <Footer {...{ disclaimerOpenTab, setDisclaimerOpenTab }} />
          </CssBaseline>
        </ThemeProvider>
      </StyledEngineProvider>
    </StylesProvider>
  );
}

export default Layout
